<template>
  <div>
    <highcharts class="hc" :options="chartOptions" ref="chart"></highcharts>
  </div>
</template>

<script>
import { ref } from 'vue'
const rainFalls = ref([])
const rainDays = ref([])
var monthData = []

export default {
  props: [ 'monthlyData' ],
  setup(props) {
    const propData = ref(props.monthlyData)
    for (var i = 1; i < 13; i++) {
      monthData = propData.value[i]
      rainFalls.value[i-1] = monthData.rainFall
      rainDays.value[i-1] = monthData.rainDays
    }
  },
  data() {
    return {
      chartOptions: {
        title: {
          text: "月別降水量・降水日数",
          x: -20 //center
        },
        xAxis: {
          categories: [
            "1月",
            "2月",
            "3月",
            "4月",
            "5月",
            "6月",
            "7月",
            "8月",
            "9月",
            "10月",
            "11月",
            "12月"
          ],
          crosshair: true
        },
        yAxis: [{ // Primary yAxis
          title: {
              text: '降水量'
          },
          labels: {
              format: '{value} mm'
          },
          max: 450, // 205 for France
        }, { // Secondary yAxis
          title: {
            text: "降水日数"
          },
          labels: {
            format: '{value}日'
          },
          max: 30,
          opposite: true
      }],
        tooltip: {
          shared: true
        },
        legend: {
          align: 'left',
          x: 80,
          verticalAlign: 'top',
          y: 60,
          floating: true
        },
        series: [{
          name: '降水量',
          type: 'column',
          data: rainFalls,
/*
          [ 47.3, 42.9, 46.2, 44.6, 64.7, 54, 58, 49.1, 46.3, 50.2, 50, 54.2 ],
*/
          tooltip: {
              valueSuffix: ' mm'
          }

      }, {
          name: '降水日数',
          type: 'line',
          yAxis: 1,
          data: rainDays,
/*
          [ 9, 8, 9, 8, 9, 8, 7, 6, 7, 8, 9, 9 ],
*/
          tooltip: {
              valueSuffix: '日'
          }

        }],
        accessibility: {
          enabled: false  // To remove highcharts accessibility warning
        }
      }
    };
  },
  watch: { // It listens to the change in props monthlyData
    monthlyData: function () {
      for (var i = 1; i < 13; i++) {
        monthData = this.monthlyData[i]
        rainFalls.value[i-1] = monthData.rainFall
        rainDays.value[i-1] = monthData.rainDays
      }
    }
  },
};
</script>
